(function ($, Drupal, drupalSettings) {

  "use strict";

  Drupal.behaviors.treston_lead_form_link = {
    attach: function(context, settings) {
      $('#lead-form-link, #lead-form-link-mobile', context).once('init-cta').each( function(index, item) {
        var form = document.querySelector($(item).attr('href'))
        if(form !== null) {
          item.parentElement.classList.add('scroll');
        }
      })
      $('#lead-form-link, #lead-form-link-mobile', context).on('click', function (event) {
        var $element = $(this).attr('href'),
        form = document.querySelector($element),
        fallbackLink = $(this).data('no-form-link');

        // If form is found, animate down to it.
        if(form !== null) {
          $('html, body').animate({
            scrollTop: $(form).offset().top
          }, 500, function(){
            window.location.hash = $element;
          });
        }
        // Redirect to Contact us-page if no form.
        else {
          event.preventDefault();
          window.location.href = fallbackLink;
        }
      });

    }
  }

})(jQuery, Drupal, drupalSettings);
